import { Reveal } from "../components/Reveal";
import { scrollToId } from "../lib/content";

const HOMES = [
  {
    src: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    label: "01 — THE VISION",
    caption: "The home you've been scrolling past, thinking \u201csomeday.\u201d",
  },
  {
    src: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    label: "02 — THE MATH",
    caption: "Someday has a number. Most first-time buyers never learn theirs.",
  },
  {
    src: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    label: "03 — THE KEYS",
    caption: "45 minutes of clarity is how the door starts to open.",
  },
];

export const LuxuryStrip = () => (
  <section className="relative py-28 md:py-36 px-6 md:px-12 overflow-hidden" style={{ background: "#EEF6EF" }} data-testid="luxury-strip-section">
    <div className="relative max-w-[1440px] mx-auto">
      <Reveal>
        <div className="flex flex-wrap items-end justify-between gap-4 mb-14">
          <div>
            <p className="chapter-label mb-6">[003.5] — WHAT YOU'RE REALLY HERE FOR</p>
            <h2 className="font-display font-bold uppercase text-3xl md:text-5xl tracking-tight">
              Stop Window-Shopping.<br /><span style={{ color: "#7C3AED" }}>Start Door-Opening.</span>
            </h2>
          </div>
          <p className="font-mono-c text-[11px] tracking-[0.2em] text-black/40">NEVADA · TEXAS</p>
        </div>
      </Reveal>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {HOMES.map((home, i) => (
          <Reveal key={i} delay={i * 0.1}>
            <figure className="group relative overflow-hidden border border-black/10" data-testid={`luxury-home-${i}`}>
              <div className="relative overflow-hidden" style={{ aspectRatio: "4/3" }}>
                <img
                  src={home.src}
                  alt="Luxury home"
                  className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
                />
                <div className="absolute inset-0 transition-opacity duration-500" style={{ background: "linear-gradient(180deg, transparent 40%, rgba(8,8,8,0.85) 100%)" }} />
                <div className="corner-mark top-3 left-3 border-t-2 border-l-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="corner-mark bottom-3 right-3 border-b-2 border-r-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <p className="absolute bottom-4 left-4 font-mono-c text-[10px] tracking-[0.3em]" style={{ color: "#c4b5fd" }}>{home.label}</p>
              </div>
              <figcaption className="p-5 text-[13px] leading-relaxed text-black/60 border-t border-black/10" style={{ background: "#ffffff" }}>
                {home.caption}
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <button onClick={() => scrollToId("register")} className="btn-accent mt-12 px-8 py-4 text-[13px]" data-testid="luxury-strip-cta">
          ✓ RESERVE MY FREE SEAT
        </button>
      </Reveal>
    </div>
  </section>
);
